/**
 * Shared sort logic for reservations table and mobile list.
 * Keeps table and mobile list order in sync when sort state is lifted to the page.
 */

import { resolveMasterChannel } from './masterChannelResolver.js';

/**
 * @param {Array} reservations
 * @param {string} sortColumn - 'check_in_date' | 'check_out_date' | 'guest_name' | 'channel' | 'nights' | 'revenue'
 * @param {'asc'|'desc'} sortDirection
 * @returns {Array} New sorted array (does not mutate input)
 */
export function sortReservations(reservations, sortColumn, sortDirection) {
  const out = [...reservations];
  out.sort((a, b) => {
    let aVal, bVal;
    if (sortColumn === 'check_in_date') {
      aVal = new Date(a.check_in_date || a.checkin_date || 0);
      bVal = new Date(b.check_in_date || b.checkin_date || 0);
    } else if (sortColumn === 'check_out_date') {
      aVal = new Date(a.check_out_date || a.checkout_date || 0);
      bVal = new Date(b.check_out_date || b.checkout_date || 0);
    } else if (sortColumn === 'guest_name') {
      aVal = (a.guest_name || a.guestName || '').toLowerCase();
      bVal = (b.guest_name || b.guestName || '').toLowerCase();
    } else if (sortColumn === 'channel') {
      const aMaster = resolveMasterChannel(
        a.channel || '',
        a.canonical_financial_summary?.channel_subtype || null,
        a.status,
        a.clc_channels || null,
        a.canonical_financial_summary || null
      );
      const bMaster = resolveMasterChannel(
        b.channel || '',
        b.canonical_financial_summary?.channel_subtype || null,
        b.status,
        b.clc_channels || null,
        b.canonical_financial_summary || null
      );
      aVal = aMaster.master_channel_label.toLowerCase();
      bVal = bMaster.master_channel_label.toLowerCase();
    } else if (sortColumn === 'nights') {
      aVal = Number(a.nights) || 0;
      bVal = Number(b.nights) || 0;
    } else if (sortColumn === 'revenue') {
      aVal = a.financials?.ownerNet != null ? Number(a.financials.ownerNet) : (Number(a.revenue) || Number(a.total_price) || 0);
      bVal = b.financials?.ownerNet != null ? Number(b.financials.ownerNet) : (Number(b.revenue) || Number(b.total_price) || 0);
    } else {
      return 0;
    }
    if (aVal < bVal) return sortDirection === 'asc' ? -1 : 1;
    if (aVal > bVal) return sortDirection === 'asc' ? 1 : -1;
    return 0;
  });
  return out;
}
